import { render } from "./ShowPlanetsTable.vue?vue&type=template&id=7d9f078a&scoped=true"
import script from "./ShowPlanetsTable.vue?vue&type=script&lang=js"
export * from "./ShowPlanetsTable.vue?vue&type=script&lang=js"

import "./ShowPlanetsTable.vue?vue&type=style&index=0&id=7d9f078a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9f078a"]])

export default __exports__